import { faMotorcycle } from "@fortawesome/fontawesome-free-solid";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Style from "./CooperationRequestForm.module.css";
const CooperationRequestForm = () => {
  const[idCartUrl,setIdCartUrl]=useState()
  const[shenasnameUrl,setShenasnameUrl]=useState()
  const[PersonImageUrl,setPersonImageUrl]=useState()
  const[soPishineImageUrl,setSopishineImageUrl]=useState()

  const ShenasnameImageHandler=(evt)=>{
    setShenasnameUrl(URL.createObjectURL(evt.target.files[0]))
}
  const cartMeliimageHandler=(evt)=>{
    setIdCartUrl(URL.createObjectURL(evt.target.files[0]))
}
  const PersonImageHandler=(evt)=>{
    setPersonImageUrl(URL.createObjectURL(evt.target.files[0]))
}
  const soPishineImageHandler=(evt)=>{
    setSopishineImageUrl(URL.createObjectURL(evt.target.files[0]))
}
  return (
    <form className={Style.FormHolder}>
      <h3>فرم ثبت نام تحویل دهنده <FontAwesomeIcon icon={faMotorcycle}/></h3>
      <hr />
      <ul className={Style.FieldsHolder}>
        <li>
          <div className={Style.PerivewImage}>{shenasnameUrl&&<img src={shenasnameUrl} className={Style.ImagePerview}  alt="" />}</div>
          <label htmlFor="shenasName" className={Style.PickImage}>
             <FontAwesomeIcon icon={faPlus} />  انتخاب تصویر شناسنامه
            <input
              type="file"
              style={{ display: "none" }}
              id={"shenasName"}
              accept="image/*"
              onChange={e=>ShenasnameImageHandler(e)}
            />
          </label>
        </li>
        <li>
          <div className={Style.PerivewImage}>{idCartUrl&&<img src={idCartUrl} className={Style.ImagePerview}  alt="" />}</div>
          <label htmlFor="cartMeli" className={Style.PickImage}>
             <FontAwesomeIcon icon={faPlus} />  انتخاب تصویر کارت ملی
            <input
              type="file"
              style={{ display: "none" }}
              id={"cartMeli"}
              accept="image/*"
              onChange={e=>cartMeliimageHandler(e)}
            />
          </label>
        </li>
        <li>
          <div className={Style.PerivewImage}>{PersonImageUrl&&<img src={PersonImageUrl} className={Style.ImagePerview}  alt="" />}</div>
          <label htmlFor="personImage" className={Style.PickImage}>
             <FontAwesomeIcon icon={faPlus} />  انتخاب عکس چهره
            <input
              type="file"
              style={{ display: "none" }}
              id={"personImage"}
              accept="image/*"
              onChange={e=>PersonImageHandler(e)}
            />
          </label>
        </li>
        <li>
          {" "}
          <div className={Style.PerivewImage}>{soPishineImageUrl&&<img src={soPishineImageUrl} className={Style.ImagePerview}  alt="" />}</div>
          <label htmlFor="soPishine" className={Style.PickImage}>
             <FontAwesomeIcon icon={faPlus} />
             انتخاب تصویر از برگه سو پیشینه
            <input
              type="file"
              style={{ display: "none" }}
              id={"soPishine"}
              accept="image/*"
              onChange={e=>soPishineImageHandler(e)}
            />
          </label>
        </li>
        <li>
          <div className={Style.PerivewImage}></div>
          <label htmlFor="cartMeli" className={Style.PickImage}>
             <FontAwesomeIcon icon={faPlus} />  شروع احرازهویت
            <input
              type="file"
              style={{ display: "none" }}
              id={"cartMeli"}
              accept="image/*"
            />
          </label>
        </li>

        <li className={Style.TextAreaHolder}>
            <label htmlFor="">آدرس محل سکونت</label>
            <textarea className={Style.TextAreaAddress} name="" id="" cols="30" rows="10"></textarea>
        </li>
      </ul>
      <button className={Style.FormButton}>ثبت</button>
    </form>
  );
};

export default CooperationRequestForm;
